<template>
    <FormControl
        required
        label="Show business name"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_UpdateCompany_ShowCompanyDisplayName,
            )
        "
    >
        <ToggleInput
            label="Show the business name in the booking form's topbar"
            :name="RequestBodyKeyEnum.App_UpdateCompany_ShowCompanyDisplayName"
            :checked="company.defaultBookingFormTheme.showCompanyDisplayName"
        />
    </FormControl>

    <FormControl
        required
        label="Show logo"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_UpdateCompany_ShowCompanyLogo,
            )
        "
    >
        <ToggleInput
            label="Show the business logo in the booking form's topbar"
            :name="RequestBodyKeyEnum.App_UpdateCompany_ShowCompanyLogo"
            :checked="company.defaultBookingFormTheme.showCompanyLogo"
        />
    </FormControl>

    <FormControl
        required
        label="Show cover image"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_UpdateCompany_ShowCompanyCover,
            )
        "
    >
        <ToggleInput
            label="Show the business cover image in booking forms"
            :name="RequestBodyKeyEnum.App_UpdateCompany_ShowCompanyCover"
            :checked="company.defaultBookingFormTheme.showCompanyCover"
        />
    </FormControl>

    <div class="flex">
        <FormControl label="Cover image position">
            <SelectInput
                class="min-w-48 max-w-48"
                :name="RequestBodyKeyEnum.App_UpdateCompany_CoverImagePosition"
                :error="
                    errors?.getValidationError(
                        RequestBodyKeyEnum.App_UpdateCompany_CoverImagePosition,
                    )
                "
                :value="company.defaultBookingFormTheme.coverImagePosition"
            >
                <option
                    v-for="coverImagePosition in CoverImagePositionEnumData"
                    :key="coverImagePosition.value"
                    :value="coverImagePosition.value"
                >
                    {{ coverImagePosition.label }}
                </option>
            </SelectInput>
        </FormControl>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import Company from '@/App/Company/Entity/Company'
    import { CoverImagePositionEnumData } from '@/Shared/AutoGenerated/Main'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import ToggleInput from '@/Shared/Component/Forms/ToggleInput.vue'
    import SelectInput from '@/Shared/Component/Forms/SelectInput.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        company: {
            type: Object as PropType<Company>,
            required: true,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })
</script>
